import { render, staticRenderFns } from "./deliveriesTable.vue?vue&type=template&id=31239313&"
import script from "./deliveriesTable.vue?vue&type=script&lang=ts&"
export * from "./deliveriesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports